<ejs-grid #grid [dataSource]="tableData" [allowReordering]="allowReordering" [childGrid]="childGrid"
    [allowSorting]="allowSorting" [allowPaging]="allowPaging" [pageSettings]="pageSettings" [height]="height"
    [allowResizing]="allowResizing" (recordClick)="onRecordClick($event)" (rowSelected)="onRowSelection($event)"
    (rowDeselected)="onRowSelection($event)" [enableHover]='true' (dataBound)='dataBound()'
    [selectionSettings]="selectionOptions" (rowDataBound)="rowDataBound($event)"
    (detailDataBound)='detailDataBound($event)' [allowFiltering]="true" [filterSettings]="filterSettings">
    <e-columns>
        @for (col of columnConfig; track col.field) {
        <e-column [field]="col.field" [headerText]="col.headerText" [filter]="col.filter ?? { type: 'CheckBox' }"
            [width]="col.width || 200" [textAlign]="col.textAlign || 'Left'"
            [allowReordering]="col.allowReordering ?? true" [allowSorting]="col.allowSorting ?? true" [type]="col.type"
            [customAttributes]="col.customAttributes" [minWidth]="col.minWidth || ''"
            [maxWidth]="col.maxWidth || ''" [allowFiltering]="col.allowFiltering ?? false" [allowResizing]="true" [format]="col.format">
            <ng-template #template let-data>
                @switch (true) {
                    <!-- Status label as drawn (redesign checkpoint 2) -->
                    @case ($safeNavigationMigration(col?.isStatusWithProgress)) {
                        @if (data[col.field]) {
                            <app-status-label [label]="data[col.field]">{{ data[col.field] }}@if (isStatusWithPercentage && data?.workOrderProgressPer >= 0 && (data[col.field] !== WorkOrderStatus.Complete) && (data[col.field] !== WorkOrderStatus.New)) {&nbsp;{{ data.workOrderProgressPer + '%' }}}</app-status-label>
                        } @else {
                            <span>-</span>
                        }
                    }
                    @case ($safeNavigationMigration(col?.isStatus)) {
                        @if (data[col.field]) {
                            <app-status-label [label]="data[col.field]" />
                        } @else {
                            <span>-</span>
                        }
                    }
                    @case ($safeNavigationMigration(col?.isDate)) {
                        {{ isValidDateValue(data[col.field]) ? (data[col.field] | date: 'dd MMM yyyy, h:mm a') : '-' }}
                    }
                    @case ($safeNavigationMigration(col?.isDateWithoutTime)) {
                        {{ isValidDateValue(data[col.field]) ? (data[col.field] | date: 'dd MMM yyyy') : '-' }}
                    }
                    @case ($safeNavigationMigration(col?.isCheckBox)) {
                        {{ data[col.field] }}
                    }
                    @case ($safeNavigationMigration(col?.isAction)) {
                        <div class="action-buttons"
                            [ngClass]="{ 'menu-open': tableType === 'sorDetails' ? onendMenuRow === data.sORCode : tableType === 'bomDetails' ? onendMenuRow === data.bOMCode :  onendMenuRow === data.id }">
                            <ng-container>
                                <!-- Standalone Actions -->
                                @if (hasEditAction()) {
                                    <button mat-icon-button (click)="onEdit(data); $event.stopPropagation()"
                                        matTooltipClass="cus-primary-tooltip" matTooltip="Edit" class="custom-button">
                                        <mat-icon class="text-white text-[18px] !w-5 !h-5 text-primary" svgIcon="c:edit"></mat-icon>
                                    </button>
                                }

                                <!-- More Actions Button -->
                                <button (click)="openActionMenu(data); $event.stopPropagation()" mat-icon-button
                                    [matMenuTriggerFor]="moreActionsMenu" aria-label="More actions" class="custom-button">
                                    <mat-icon class="text-white text-[20px] !w-5 !h-5 text-primary" svgIcon="c:dots-vertical"></mat-icon>
                                </button>

                                <!-- Angular Material Menu -->
                                <mat-menu (closed)="onActionMenuClose()" #moreActionsMenu="matMenu"
                                    class="action-menu !bg-white">
                                    @for (actionButton of col.actions; track $index) {
                                        @if (actionButton.buttonCaption?.toLowerCase() !== 'edit') {
                                            <button mat-menu-item
                                                style="--mat-menu-item-hover-state-layer-color: var(--color-selected-bg);"
                                                (click)="onActionClick(actionButton, data)">
                                                @if ((actionButton.iconName) | brandIcon; as brandSvg) { <mat-icon class="{{ actionButton.className }}" [svgIcon]="brandSvg"></mat-icon> } @else { <mat-icon class="{{ actionButton.className }}">{{ actionButton.iconName }}</mat-icon> }
                                                <span class="font-sans font-medium">{{ actionButton.buttonCaption }}</span>
                                            </button>
                                        }
                                    }
                                </mat-menu>
                            </ng-container>
                        </div>
                    }
                    @case ($safeNavigationMigration(col?.isLink)) {
                        <a class="text-primary border-b-[1px] border-primary"
                            [href]="'/work-orders/workOrderDetails?childWorkOrderId=' + data.id + '&parentWoCode=' + (col?.routerData?.woCode || '')"
                            target="_self">
                            {{ data[col.field] }}
                        </a>
                    }
                    @case ($safeNavigationMigration(col?.isNumber)) {
                        {{ data[col.field] || 0 }}
                    }
                    @default {
                        {{ data[col.field] || '-' }}
                    }
                }
            </ng-template>
        </e-column>
        }
    </e-columns>

    <!-- Empty Record Template -->
    <ng-template #emptyRecordTemplate>
        <div class="flex justify-center items-center max-w-[100vw] p-5 flex-col gap-2">
            <img src="../../../../assets/images/emptyRecordTemplate_light.svg" class="e-emptyRecord" alt="No record" />
            <span>There is no data available to display at the moment.</span>
        </div>
    </ng-template>
</ejs-grid>
